<template>
    <div class="select_product">
        <section class="breadcrumb-section custome_breadCrumb_space pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item">
                            <a href="#">Team Store</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Custom Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="wizard d-flex justify-content-center align-items-center"
                        >
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Basic Information</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">2</div>
                                <h5 class="mb-0">Select Product</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">3</div>
                                <h5 class="mb-0">Design</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">4</div>
                                <h5 class="mb-0">Shipping</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">5</div>
                                <h5 class="mb-0">Publish</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="select_products team_store_select_product_sec pt_64 pb_94"
        >
            <div class="container">
                <div class="row team_store">
                    <div class="col-md-12 search_for_product">
                        <div
                            class="heading_with_search d-md-flex align-items-center"
                        >
                            <div>
                                <h1 class="heading1 m-0">Select Product</h1>
                                <h5 class="heading5 opacity_60 m-0 st_regis_p">
                                    St Regis
                                </h5>
                            </div>
                            <div
                                class="serach d-flex ml-auto position-relative"
                            >
                                <label>Search</label>
                                <div class="search_field pl_24">
                                    <input
                                        type="text"
                                        placeholder="e.g. T-Shirt, Cap"
                                        class="form-control"
                                    />
                                    <a href="#" class="search_icon"
                                        ><img
                                            src="/maincss/images/side_bar_serach.svg"
                                            alt=" "
                                    /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt_20">
                    <div class="col-md-12 col-lg-12 col-xl-9">
                        <div class="row">
                            <div class="col-md-6 col-lg-4 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/select_product1.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        />
                                        <span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div class="form-check pl-0 py_6">
                                            <label class="checkbox_custom">
                                                <input type="checkbox" /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                    <div class="product_content mt_24">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div class="form-check pl-0 py_6">
                                            <label
                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                >Mandatory Item
                                                <input
                                                    type="checkbox"
                                                    checked="checked" /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative checked_active"
                                    >
                                        <img
                                            src="/maincss/images/select_product2.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        />
                                        <span
                                            class="offer-badge px_20 py_2 bg_primary_red font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div class="form-check pl-0 py_6">
                                            <label class="checkbox_custom">
                                                <input
                                                    type="checkbox"
                                                    checked /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                    <div class="product_content mt_24">
                                        <h5 class="heading5">
                                            Classic C-Handle 11oz Mugs
                                        </h5>
                                        <div class="form-check pl-0 py_6">
                                            <label
                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                >Mandatory Item
                                                <input type="checkbox" /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative checked_active"
                                    >
                                        <img
                                            src="/maincss/images/select_product3.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        />
                                        <span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div class="form-check pl-0 py_6">
                                            <label class="checkbox_custom">
                                                <input
                                                    type="checkbox"
                                                    checked /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                    <div class="product_content mt_24">
                                        <h5 class="heading5">Sweatshirts</h5>
                                        <div class="form-check pl-0 py_6">
                                            <label
                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                >Mandatory Item
                                                <input type="checkbox" /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/select_product4.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        />
                                        <span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div class="form-check pl-0 py_6">
                                            <label class="checkbox_custom">
                                                <input type="checkbox" /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                    <div class="product_content mt_24">
                                        <h5 class="heading5">
                                            Custom Classic Soft Crown Caps
                                        </h5>
                                        <div class="form-check pl-0 py_6">
                                            <label
                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                >Mandatory Item
                                                <input type="checkbox" /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative checked_active"
                                    >
                                        <img
                                            src="/maincss/images/select_product5.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        />
                                        <span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div class="form-check pl-0 py_6">
                                            <label
                                                class="checkbox_custom d-inline-block"
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                    <div class="product_content mt_24">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div class="form-check pl-0 py_6">
                                            <label
                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                >Mandatory Item
                                                <input type="checkbox" /><span
                                                    class="checkmark"
                                                ></span
                                            ></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 col-xl-4">
                                <div class="product">
                                    <a
                                        href="#"
                                        class="product_image d-flex justify-content-center checked_active product_upload"
                                    >
                                        <img
                                            src="/maincss/images/add_more_brand.svg"
                                            alt=" "
                                        />
                                        <p
                                            class="font_size_20 text_primary_blue mt_14 mb-0"
                                        >
                                            Add Product
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 col-xl-3">
                        <div
                            class="cart_summary white_box bg_primary_light_white px_30 py_30"
                        >
                            <h4 class="font_size_30 d-flex mb_28">
                                3 Selected
                            </h4>
                            <div class="cart_items media">
                                <img
                                    src="/maincss/images/select_product_thumb.png"
                                    alt=""
                                    class="mr_10 cart_product_image"
                                />
                                <div class="media-body">
                                    <h4 class="font_size_20 d-md-flex mb-0">
                                        Classic C-Handle 11oz Mugs
                                    </h4>
                                    <p
                                        class="font_size_16 mt_4 mb-0 text_light_grey"
                                    >
                                        Mug
                                    </p>
                                    <p
                                        class="font_size_16 mb-0 text_light_grey"
                                    >
                                        XS: 10, S: 2 Edit
                                    </p>
                                </div>
                                <div class="price_product">
                                    <span class="font_size_22 ml-auto"
                                        >$2.00</span
                                    >
                                </div>
                            </div>
                            <div class="cart_items media">
                                <img
                                    src="/maincss/images/select_product_thumb_1.png"
                                    alt=""
                                    class="mr_10 cart_product_image"
                                />
                                <div class="media-body">
                                    <h4 class="font_size_20 d-md-flex mb-0">
                                        Sweatshirts
                                    </h4>
                                    <p
                                        class="font_size_16 mt_4 mb-0 text_light_grey"
                                    >
                                        T-Shirt
                                    </p>
                                    <p
                                        class="font_size_16 mb-0 text_light_grey"
                                    >
                                        M: 1
                                    </p>
                                </div>
                                <div class="price_product">
                                    <span class="font_size_22 ml-auto"
                                        >$2.00</span
                                    >
                                </div>
                            </div>
                            <div class="cart_items media">
                                <img
                                    src="/maincss/images/select_product_thumb_2.png"
                                    alt=""
                                    class="mr_10 cart_product_image"
                                />
                                <div class="media-body">
                                    <h4 class="font_size_20 d-md-flex mb-0">
                                        Custom Classic Soft Crown Caps
                                    </h4>
                                    <p
                                        class="font_size_16 mt_4 mb-0 text_light_grey"
                                    >
                                        Cap
                                    </p>
                                    <p
                                        class="font_size_16 mb-0 text_light_grey"
                                    >
                                        S: 1
                                    </p>
                                </div>
                                <div class="price_product">
                                    <span class="font_size_22 ml-auto"
                                        >$2.00</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="buttons mt_22 ml-auto text-right">
                            <a
                                href="/team/custom-store"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52 mr_34"
                                >BACK</a
                            >
                            <a
                                href="/team/design-team-store"
                                class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                                >Next</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "SelectProduct",
    components: {},
    mounted() {
        document.body.classList.add("");
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
